import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import Datefield from '@/components/layout/datefield/Datefield.vue'
import Timefield from '@/components/layout/timefield/Timefield.vue'
import pagination from '@/components/layout/pagination/Pagination.vue'
import { BToast, BSpinner } from 'bootstrap-vue'
import { mapState } from 'vuex'
import constants from '@/util/constants'
import mensagens from '@/util/mensagens'
import util from '@/util'

export default {
  name: 'cadastro-eventos',
  components: {
    cabecalho,
    menuLateral,
    Datefield,
    Timefield,
    pagination,
    'default-table': defaultTable,
    'b-spinner': BSpinner,
    'b-toast': BToast
  },

  computed: {
    ...mapState('auth', ['nomeUsuarioLogado']),
    ...mapState('pagination', ['registrosPorPagina']),

    exibirBotaoExcluir () {
      return !util.valorVazio(this.formulario.f_uuid)
    },

    eventoEhRecorrente () {
      return !util.valorEhNulo(this.formulario.f_recurrence_id)
    },

    desabilitaCampo () {
      return this.estaRealizandoProcessamento() || this.deveDesabilitarCamposPorRegra() || this.eventoNaoLocalizadoOuCancelado
    },

    desabilitaBotaoExcluir () {
      return this.estaRealizandoProcessamento() || !this.ehProprietarioDoEvento || this.eventoNaoLocalizadoOuCancelado
    },

    desabilitaNavegacaoParticipantes () {
      return this.estaRealizandoProcessamento() || this.eventoNaoLocalizadoOuCancelado || !this.estaEditandoEvento || this.existeParticipanteNaoPersistido() || !this.fonteDeDadosParticipantes
    },

    apresentarTerminoOcorrencia () {
      return !util.valorEhNulo(this.formulario.recurrence)
    },

    estaEditandoEvento () {
      return !util.valorVazio(this.formulario.f_uuid)
    },

    rotuloBotaoConfirmacaoModal () {
      if (this.acaoDeCadastro === constants.acoesCadastroEventoAgenda.salvar) {
        return 'Salvar'
      }
      return 'Excluir'
    },

    tituloConfirmacaoModal () {
      if (this.acaoDeCadastro === constants.acoesCadastroEventoAgenda.salvar) {
        return 'Deseja alterar?'
      }
      return 'Deseja excluir?'
    },

    estiloBotaoConfirmacaoModal () {
      if (this.acaoDeCadastro === constants.acoesCadastroEventoAgenda.salvar) {
        return 'outline-success btn-sm'
      }
      return 'outline-danger btn-sm'
    },

    comboUnidadesFiltradas () {
      if (!this.unidadesSelecionadas.length) {
        return this.comboUnidadesDisponiveis
      }

      const selecionadasIds = this.unidadesSelecionadas.map(u => u.f_id)

      return this.comboUnidadesDisponiveis.filter(
        u => !selecionadasIds.includes(u.f_id)
      )
    }

  },

  data: () => {
    return {
      formulario: {
        f_uuid: null,
        f_summary: '',
        f_dtstamp: new Date(),
        f_dtstart: null,
        f_hour_begin: '',
        f_dtend: null,
        f_hour_end: '',
        f_location: '',
        f_description: '',
        f_status: null,
        f_participants: [],
        f_owner: null,
        f_organizer: null,
        organizer: [],
        f_recurrence_id: null,
        recurrence: null,
        recurrence_final_date: null,
        afetarTodosEventos: false,
        f_allday: false
      },
      listaParticipantes: [],
      participantesParaExcluir: [],
      fonteDeDadosParticipantes: {
        paginaAtual: 0,
        ultimaPagina: 0,
        totalRegistros: 0,
        registrosPorPagina: 10
      },
      paginaAtualParticipantes: 1,
      registrosPorPaginaParticipantes: 10,
      acaoDeCadastro: null,
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        },
        manipulandoDados: {
          status: false,
          mensagem: ''
        }
      },
      dadosRetorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: []
      },
      componenteOrdenacao: {
        campo: 'f_name',
        sentido: 'asc'
      },
      timeOutDigitacaoNocombo: null,
      listaParticipantesDisponiveis: [],
      comboParticipantesDisponiveis: [],
      totalParticipantesInternos: null,
      participanteSelecionado: null,
      fieldsParticipantes: [
        { key: 'f_name', sortable: true, label: 'Nome' },
        { key: 'f_email', sortable: true, label: 'E-mail' },
        { key: 'f_status', sortable: false, label: 'Situação' },
        { key: 'opcoes', sortable: false, label: 'Opções' }
      ],
      podeEditarEvento: true,
      ehProprietarioDoEvento: null,
      eventoNaoLocalizadoOuCancelado: false,
      recorrenciaEventoOptions: [
        { text: constants.tipoRecorrenciaEventoAgenda.semRecorrenciaLabel, value: constants.tipoRecorrenciaEventoAgenda.semRecorrencia },
        { text: constants.tipoRecorrenciaEventoAgenda.diarioLabel, value: constants.tipoRecorrenciaEventoAgenda.diario },
        { text: constants.tipoRecorrenciaEventoAgenda.semanalLabel, value: constants.tipoRecorrenciaEventoAgenda.semanal },
        { text: constants.tipoRecorrenciaEventoAgenda.mensalLabel, value: constants.tipoRecorrenciaEventoAgenda.mensal }
      ],
      unidadesSelecionadas: [],
      comboUnidadesDisponiveis: [],
      timeOutDigitacaoNoComboUnidades: null
    }
  },

  mounted () {
    let id = this.$route.params.id
    if (!util.valorEhNulo(id)) {
      this.obterEvento(id)
    } else {
      this.iniciarDadosFormularioDoEvento()
    }
    this.obterParticipantesDisponiveis()
    this.obterUnidadesDisponiveis()
  },

  methods: {
    tabelaSemRegistros (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center'
      }
    },

    estaRealizandoProcessamento () {
      return this.flagsDeControle.manipulandoDados.status || this.flagsDeControle.carregandoDados.status
    },

    deveDesabilitarCamposPorRegra () {
      return !this.ehProprietarioDoEvento || !this.podeEditarEvento
    },

    async obterEvento (id) {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

        const resposta = await this.axios.get('/agenda/evento/' + id)
        this.formulario.f_uuid = resposta.data.retorno.dados.f_uuid
        this.formulario.f_summary = resposta.data.retorno.dados.f_summary
        this.formulario.f_dtstamp = util.formatarData(resposta.data.retorno.dados.f_dtstamp)
        this.formulario.f_dtstart = util.formatarData(resposta.data.retorno.dados.f_dtstart, 'YYYY-MM-DD')
        this.formulario.f_hour_begin = util.formatarData(resposta.data.retorno.dados.f_dtstart, 'HH:mm')
        this.formulario.f_dtend = util.formatarData(resposta.data.retorno.dados.f_dtend, 'YYYY-MM-DD')
        this.formulario.f_hour_end = util.formatarData(resposta.data.retorno.dados.f_dtend, 'HH:mm')
        this.formulario.f_location = resposta.data.retorno.dados.f_location
        this.formulario.f_description = resposta.data.retorno.dados.f_description
        this.formulario.f_status = resposta.data.retorno.dados.f_status
        this.formulario.f_owner = resposta.data.retorno.dados.f_owner
        this.formulario.f_organizer = resposta.data.retorno.dados.f_organizer
        this.formulario.organizer = this.obterOrganizadorDoEvento(resposta.data.retorno.dados.organizer)
        this.formulario.f_recurrence_id = resposta.data.retorno.dados.f_recurrence_id
        this.formulario.recurrence = util.valorEhNulo(resposta.data.retorno.dados.recurrence) ? null : resposta.data.retorno.dados.recurrence.f_freq
        this.formulario.recurrence_final_date = util.valorEhNulo(resposta.data.retorno.dados.recurrence) ? null : util.formatarData(resposta.data.retorno.dados.recurrence.f_until, 'YYYY-MM-DD')
        this.podeEditarEvento = resposta.data.retorno.dados.f_edit_enabled
      } catch (e) {
        if (e.response.status === 404) {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagens.eventoNaoLocalizadoOuCancelado)
          this.eventoNaoLocalizadoOuCancelado = true
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
        }
      }
      this.verificarPermissaoParaAlterarEvento()
      this.definirFlagCarregandoDados(false, '')
      await this.carregarParticipantesPaginados()
    },

    obterOrganizadorDoEvento (dados) {
      return dados.f_name
    },

    iniciarDadosFormularioDoEvento () {
      this.ehProprietarioDoEvento = true
      this.formulario.organizer = this.nomeUsuarioLogado
    },

    obterListaDeParticipantes (listaParticipantes) {
      let lista = []
      for (let indice in listaParticipantes) {
        let participante = listaParticipantes[indice]
        let participanteEhInterno = !util.valorVazio(participante.user)
        lista.push({
          'f_email': participante.f_email,
          'f_event': participante.f_event,
          'f_id': participante.f_id,
          'f_name': participanteEhInterno ? participante.user.f_name : participante.f_email,
          'f_status': this.obterStatusDoConvite(participante)
        })
      }
      return lista
    },

    obterStatusDoConvite (participante) {
      let participanteEhInterno = !util.valorVazio(participante.user)
      let temRetornoDoConvite = !util.valorVazio(participante.invites)

      let status = ''
      if (participanteEhInterno) {
        if (temRetornoDoConvite) {
          status = participante.invites.f_status
        } else {
          status = constants.statusConvites.pendente
        }
      }

      switch (status) {
        case 1:
          return constants.statusConvites.pendenteLabel
        case 2:
          return constants.statusConvites.aceitoLabel
        case 3:
          return constants.statusConvites.rejeitadoLabel
      }
    },

    verificarPermissaoParaAlterarEvento () {
      this.ehProprietarioDoEvento = (this.formulario.f_owner === this.formulario.f_organizer)
    },

    async salvarRegistro () {
      this.acaoDeCadastro = constants.acoesCadastroEventoAgenda.salvar
      this.resetarListaDeErros()

      if (!this.validarPreenchimentoCamposDataHora()) return

      if ((this.estaEditandoEvento) && (this.eventoEhRecorrente)) {
        this.$bvModal.show('modalConfirmacao')
      } else {
        this.executarSalvarRegistro()
      }
    },

    async executarSalvarRegistro () {
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      try {
        let resposta = null
        let dataInicio = this.obterDataInicio()
        let dataTermino = this.obterDataTermino()

        let dadosFormulario = util.mapearObjetos(this.formulario, {})

        dadosFormulario.f_dtstamp = util.formatarData(new Date())
        dadosFormulario.f_dtstart = util.formatarData(dataInicio, 'DD/MM/YYYY HH:mm')
        dadosFormulario.f_dtend = util.formatarData(dataTermino, 'DD/MM/YYYY HH:mm')
        dadosFormulario.recurrence_final_date = util.formatarData(dadosFormulario.recurrence_final_date, 'DD/MM/YYYY')
        dadosFormulario.recurrence_change_all = this.formulario.afetarTodosEventos
        dadosFormulario.f_status = constants.statusEvento.confirmado
        dadosFormulario.f_participants = this.removerFUserDosParticipantes(this.listaParticipantes).filter(({ selecionadoParaExclusao, f_id: fId }) => util.valorVazio(fId) && !selecionadoParaExclusao)
        dadosFormulario.participantes_para_excluir = this.obterIdentificadoresDosParticipantesExcluidos(this.participantesParaExcluir)
        dadosFormulario.f_units = this.unidadesSelecionadas.map(unidade => unidade.f_id)

        if (this.estaEditandoEvento) {
          resposta = await this.axios.put('/agenda/evento/salvar', dadosFormulario)
        } else {
          resposta = await this.axios.post('/agenda/evento/salvar', dadosFormulario)
        }

        this.dadosRetorno.sucesso = resposta.data.retorno.sucesso
        this.dadosRetorno.mensagem = resposta.data.retorno.mensagem
        this.dadosRetorno.listaDeErros = resposta.data.retorno.listaDeErros
        this.tratarAposSalvarRegistro()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      }
      this.definirFlagManipulandoDados(false, '')
    },

    obterDataInicio () {
      let dataInicio = util.valorVazio(this.formulario.f_dtstart) ? this.formulario.f_dtstart : this.formulario.f_dtstart.concat(' ').concat(this.formulario.f_hour_begin)
      return dataInicio
    },

    obterDataTermino () {
      let dataTermino = util.valorVazio(this.formulario.f_dtend) ? this.formulario.f_dtend : this.formulario.f_dtend.concat(' ').concat(this.formulario.f_hour_end)
      return dataTermino
    },

    tratarAposSalvarRegistro () {
      if (this.dadosRetorno.sucesso) {
        this.$router.push({ name: 'agenda' }).then(() => {
          util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
        })
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', this.dadosRetorno.mensagem)
      }
    },

    validarPreenchimentoCamposDataHora () {
      let dataHoraInicioPreenchido = true
      if (!util.valorVazio(this.formulario.f_dtstart) && !util.ehValidoFormatoHora(this.formulario.f_hour_begin)) {
        this.dadosRetorno.listaDeErros['f_hour_begin'] = 'Digite um formato válido: HH:mm'
        dataHoraInicioPreenchido = false
      }

      let dataHoraTerminoPreenchido = true
      if (!util.valorVazio(this.formulario.f_dtend) && !util.ehValidoFormatoHora(this.formulario.f_hour_end)) {
        this.dadosRetorno.listaDeErros['f_hour_end'] = 'Digite um formato válido: HH:mm'
        dataHoraInicioPreenchido = false
      }
      if (!dataHoraInicioPreenchido || !dataHoraTerminoPreenchido) {
        return false
      } else {
        return true
      }
    },

    async excluirRegistro () {
      this.acaoDeCadastro = constants.acoesCadastroEventoAgenda.excluir
      if (this.eventoEhRecorrente) {
        this.$bvModal.show('modalConfirmacao')
      } else {
        this.executarExcluirRegistro()
      }
    },

    async executarExcluirRegistro () {
      this.definirFlagManipulandoDados(true, mensagens.excluindoDadosCadastro)
      try {
        const resposta = await this.axios.delete('/agenda/evento/remover/' + this.formulario.f_uuid + '?recurrenceRemoveAll=' + this.formulario.afetarTodosEventos)
        this.dadosRetorno.sucesso = resposta.data.retorno.sucesso
        this.dadosRetorno.mensagem = resposta.data.retorno.mensagem

        if (this.dadosRetorno.sucesso) {
          this.$router.push({ name: 'agenda' }).then(() => {
            util.criarAlertaToastDeSucesso(this, 'Aviso', 'Evento removido com sucesso.')
          })
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', this.dadosRetorno.mensagem)
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaComunicacaoServidor)
      }
      this.definirFlagManipulandoDados(false, '')
    },

    executarConfirmacaoModal () {
      if (this.acaoDeCadastro === constants.acoesCadastroEventoAgenda.salvar) {
        this.executarSalvarRegistro()
        return false
      }

      if (this.acaoDeCadastro === constants.acoesCadastroEventoAgenda.excluir) {
        this.executarExcluirRegistro()
        return false
      }
    },

    preencherDataHoraTerminoCalculado () {
      if (!util.valorVazio(this.formulario.f_uuid)) {
        return
      }

      if (util.valorVazio(this.formulario.f_dtstart) || !util.ehValidoFormatoHora(this.formulario.f_hour_begin)) {
        return
      }
      const dataManipulada = util.adicionarMaisHorasAData(this.obterDataInicio())
      this.formulario.f_dtend = util.formatarData(dataManipulada, 'DD/MM/YYYY')
      this.$refs.dateFieldEnd.inputValue = this.formulario.f_dtend
      this.formulario.f_hour_end = util.formatarData(dataManipulada, 'HH:mm')
      this.formulario.f_dtend = util.formatarData(dataManipulada, 'YYYY-MM-DD')
    },

    eventoDigitarBuscaPorParticipante (valorDigitadoParaBusca, callbackFlagCarregamento) {
      this.dadosRetorno.listaDeErros = []

      clearTimeout(this.timeOutDigitacaoNocombo)
      let referenciaObjetoDaView = this

      this.timeOutDigitacaoNocombo = setTimeout(function () {
        referenciaObjetoDaView.obterParticipantesDisponiveis(valorDigitadoParaBusca, callbackFlagCarregamento)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async obterParticipantesDisponiveis (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }
      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'f_name': valorDigitadoParaBusca }
      }

      let resposta = await this.axios.post('/agenda/filtrar/participantes/internos', parametrosRequisicao)
      this.listaParticipantesDisponiveis = resposta.data.retorno.dados
      this.comboParticipantesDisponiveis = this.listaParticipantesDisponiveis

      callbackFlagCarregamento = false
    },

    customizarLabel (val) {
      let nome = val.f_name
      let email = val.f_email
      if (typeof val === 'object') {
        if (!util.valorVazio(email)) {
          return nome + ' <' + email + '>'
        } else {
          return nome
        }
      } else {
        return val
      }
    },

    validarDadosParticipante () {
      this.resetarListaDeErros()
      let emailParticipante = this.obterEmailDoParticipante()

      const participanteJaExiste = this.listaParticipantes.some((participante) => participante.f_email === emailParticipante)
      if (participanteJaExiste) {
        this.dadosRetorno.listaDeErros['f_participants.*.'] = 'O e-mail do participante deve ser único'
      } else {
        if (!util.validarEmail(emailParticipante)) {
          this.dadosRetorno.listaDeErros['f_participants.*.'] = 'Informe um e-mail válido'
        }
      }
    },

    adicionarUmParticipante () {
      let participante = this.participanteSelecionado
      const emailParticipante = this.obterEmailDoParticipante()
      const idParticipante = participante.f_id
      const nomeParticipante = participante.f_name

      const obj = {
        'f_user': !util.valorVazio(idParticipante) ? idParticipante : null,
        'f_email': emailParticipante,
        'f_name': !util.valorVazio(nomeParticipante) ? nomeParticipante : emailParticipante
      }

      this.listaParticipantes.push(obj)
      this.resetarAutoCompleteDeParticipantes()
    },

    async adicionarNaLista () {
      this.resetarListaDeErros()
      if (util.valorEhNulo(this.participanteSelecionado)) {
        this.dadosRetorno.listaDeErros['participanteSelecionado'] = 'Selecione um participante'
        return
      }
      this.validarDadosParticipante()
      if (!util.valorVazio(this.dadosRetorno.listaDeErros['f_participants.*.'])) {
        return
      }
      this.adicionarUmParticipante()
    },

    obterEmailDoParticipante () {
      let participante = this.participanteSelecionado
      let email = null
      if (typeof participante === 'object') {
        email = !util.valorVazio(participante.f_email) ? participante.f_email : participante.f_name
      } else {
        email = participante
      }
      return email
    },

    resetarAutoCompleteDeParticipantes () {
      this.participanteSelecionado = null
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    resetarListaDeErros () {
      this.dadosRetorno.sucesso = false
      this.dadosRetorno.mensagem = ''
      this.dadosRetorno.listaDeErros = []
    },

    resetarListaParticipantesFormulario () {
      this.listaParticipantes = []
    },

    removerListaParticipantesInternos () {
      this.listaParticipantes = this.listaParticipantes.filter((participante) => participante.f_user === null)
    },

    voltarRotaAnterior () {
      this.$router.push({ name: 'agenda' })
    },

    removerFUserDosParticipantes (lista) {
      if (!Array.isArray(lista)) {
        throw new Error('Esperado um array de participantes')
      }

      return lista.map(participante => {
        const { f_user: fUser, f_id: fId, ...resto } = participante
        const ehParticipanteNovo = util.valorVazio(fId)
        if (!ehParticipanteNovo && this.estaEditandoEvento) {
          return { f_id: fId, ...resto }
        }

        return { ...resto, f_user: fUser, f_id: fId }
      })
    },

    async carregarParticipantesPaginados () {
      if (util.valorVazio(this.formulario.f_uuid)) {
        return
      }

      try {
        this.flagsDeControle.carregandoDados.status = true
        this.registrosPorPaginaParticipantes = this.registrosPorPagina
        const resposta = await this.axios.post(`/agenda/evento/${this.formulario.f_uuid}/participantes/paginados`, {
          page: this.paginaAtualParticipantes,
          registrosPorPagina: this.registrosPorPaginaParticipantes,
          ordenacao: this.componenteOrdenacao,
          filtros: {}
        })

        const { dados, paginacao } = resposta.data.retorno
        this.listaParticipantes = this.obterListaDeParticipantes(dados)
        this.listaParticipantes = this.listaParticipantes.map(participante => ({
          ...participante,
          selecionadoParaExclusao: this.verificarSeEstaMarcadoParaExclusao(participante)
        }))
        this.fonteDeDadosParticipantes = {
          paginaAtual: paginacao.paginaAtual,
          ultimaPagina: paginacao.ultimaPagina,
          totalRegistros: paginacao.totalRegistros,
          registrosPorPagina: paginacao.registrosPorPagina
        }
      } catch (erro) {
        console.error(erro)
        util.criarAlertaToastDeErro(this, 'Aviso', 'Não foi possível carregar os participantes do evento.')
      } finally {
        this.flagsDeControle.carregandoDados.status = false
      }
    },

    navegarNaPaginacaoParticipantes (pagina, registrosPorPagina) {
      this.paginaAtualParticipantes = pagina
      this.registrosPorPaginaParticipantes = registrosPorPagina
      this.carregarParticipantesPaginados()
    },

    marcarParticipanteParaExclusao (participante) {
      if (this.desabilitaCampo || util.valorVazio(participante)) {
        return
      }

      const indice = this.participantesParaExcluir.findIndex(
        p => p.f_id === participante.f_id
      )

      if (indice > -1) {
        this.participantesParaExcluir.splice(indice, 1)
        participante.selecionadoParaExclusao = false
      } else {
        this.participantesParaExcluir.push({ ...participante })
        participante.selecionadoParaExclusao = true
      }
    },

    verificarSeEstaMarcadoParaExclusao (participante) {
      if (util.valorVazio(participante?.f_id)) {
        return false
      }

      return this.participantesParaExcluir.some(
        p => p.f_id === participante.f_id
      )
    },

    removeParticipanteNaoPersistido (participante) {
      const indice = this.listaParticipantes.indexOf(participante)

      if (indice < 0) return

      this.listaParticipantes.splice(indice, 1)
    },

    abrirModalParticipantesMarcadosParaExclusao () {
      window.$('#modalExclusoes').modal('show')
    },

    removerParticipanteDaListaDeExclusao (participante) {
      this.participantesParaExcluir = this.participantesParaExcluir.filter(
        participanteParaExcluir => participanteParaExcluir.f_id !== participante.f_id
      )

      const indice = this.listaParticipantes.findIndex(
        p => p.f_id === participante.f_id
      )

      if (indice === -1) {
        return
      }

      this.listaParticipantes[indice].selecionadoParaExclusao = false
    },

    desmarcarTodosParticipantesParaExclusao () {
      this.participantesParaExcluir = []

      this.listaParticipantes = this.listaParticipantes.map(participante => ({
        ...participante,
        selecionadoParaExclusao: false
      }))
    },

    obterIdentificadoresDosParticipantesExcluidos () {
      if (this.participantesParaExcluir.length === 0) {
        return []
      }

      return this.participantesParaExcluir.map(p => ({ f_id: p.f_id, f_email: p.f_email }))
    },

    existeParticipanteNaoPersistido () {
      return this.listaParticipantes.some(
        participante => util.valorVazio(participante.f_id)
      )
    },

    onSortChanged ({ sortBy, sortDesc }) {
      if (this.existeParticipanteNaoPersistido()) {
        return
      }

      this.componenteOrdenacao = {
        campo: sortBy,
        sentido: sortDesc ? 'desc' : 'asc'
      }
      this.carregarParticipantesPaginados()
    },

    eventoDigitarBuscaPorUnidade (valorDigitado, callbackFlagCarregamento) {
      clearTimeout(this.timeOutDigitacaoNoComboUnidades)

      this.timeOutDigitacaoNoComboUnidades = setTimeout(() => {
        this.obterUnidadesDisponiveis(valorDigitado, callbackFlagCarregamento)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async obterUnidadesDisponiveis (valorDigitado = '', callbackFlagCarregamento = null) {
      try {
        if (callbackFlagCarregamento) callbackFlagCarregamento(true)

        const parametrosRequisicao = {
          registrosPorPagina: constants.defaultRegistrosCombo,
          filtros: {
            f_name: valorDigitado
          }
        }

        const resposta = await this.axios.post(
          '/agenda/filtrar/unidades/participantes/internos',
          parametrosRequisicao
        )

        this.comboUnidadesDisponiveis = resposta.data.retorno.dados
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', 'Não foi possível carregar as unidades.')
      } finally {
        if (callbackFlagCarregamento) callbackFlagCarregamento(false)
      }
    }

  }
}
